import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Message, SelectItem } from 'primeng/primeng';
import { CreateCategoryGroup } from '../../../../../models/inModels/CategoryGroup';
import { BusinessService } from '../../../../../services/business/business-category.service';
import { StorageService } from '../../../../../services/system/storage.service';

@Component({
  selector: 'app-category-group-create',
  templateUrl: './category-group-create.component.html',
  styleUrls: ['./category-group-create.component.css']
})
export class CategoryGroupCreateComponent implements OnInit {
  model: CreateCategoryGroup;
  loading: boolean = false;
  groups: SelectItem[];
  error: Message[];
  selectedGroup;
  upolading = false;
  constructor(
    private router: Router,
    private businessService: BusinessService,
    public storageService: StorageService
  ) { 
    this.model = new CreateCategoryGroup();
  }

  ngOnInit() {
  }

  goBack(): void {
    this.router.navigate(['business-category/groups'])
  }

  save() {
    console.log(this.model);
    this.loading = true;
    this.businessService.createGroup(this.model).then(
      result => {
        this.loading = false;
        this.goBack();
      },
      error => {
        this.loading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error})
      }
    )
  }

  handleImage(event): void {
		var result = this.storageService.handleSuccess(event);

		this.model.icon = result.PublicId;
		this.loading = false;
  }
  
  handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

}



// WEBPACK FOOTER //
// ./src/app/components/business/business-category/category-group/category-group-create/category-group-create.component.ts